import React from 'react'
import PropTypes from 'prop-types'

import Layout from 'components/Layout/SplitLayout'
import Loader from 'sharedComponents/Loader'
import HeaderOne from 'sharedComponents/HeaderOne'
import Text from 'sharedComponents/Text'
import { Button, ErrorText } from 'components/Forms'
import style from './style.module.scss'

InvitationPetParentEmailAcceptedScreen.propTypes = {
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  contact: PropTypes.object,
}

function InvitationPetParentEmailAcceptedScreen(props) {
  const { isLoading, petParent, type, error } = props

  if (isLoading) {
    return <Loader />
  }
  if (error) {
    return (<Layout showNav={false}>
        <ErrorText>{error}</ErrorText>
      </Layout>
    )
  }
  
  const { user } = petParent

  return (
    <Layout showNav={false}>
      <HeaderOne className={style.header}>
        You’ve been added as a Pet Parent for {user.firstName}
      </HeaderOne>

      <div className={style.textBlock}>
        <Text className={style.text}>
          As a Pet Notify pet parent, you’re now able to receive automated {type === 'email' ? 'email' : 'SMS'} and SMS notifications when your pet needs help.
        </Text>
      </div>
      <Button href='https://www.petnotify.com/' target='_blank'>
        Learn more about Pet Notify
      </Button>
    </Layout>
  )
}

export default InvitationPetParentEmailAcceptedScreen
